import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const options = {
  credentials: 'omit',
  circuitBreaker: {
    id: 'creditDecision',
    timeout: 5000,
    resetTimeout: 300000,
    fallback: {
      error: 'Circuit Breaker for /credit/decision is open'
    }
  },
  headers: {
    'X-fwd-svc': 'atc',
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
};
function creditApplicationFetcher(path) {
  return {
    path: path + 'my-wallet/credit/decision',
    async fetch(query) {
      try {
        const data = await fetchJSON(this.path, getFetchOptions({
          ...options,
          query
        }));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching credit application details: ', error);
      }
      return {};
    }
  };
}
export { creditApplicationFetcher as default };
